import currency from "currency.js";

// ref: https://github.com/scurker/currency.js/issues/191#issuecomment-529201820
export function omitZeroCents(currency, options) {
	// call original format function to get its string value
	let format = options.format(currency, options);

	if(currency.cents() === 0) {
		// trim decimal and any trailing zeros
		return format.slice(0, format.length - (options.precision + 1));
	}

	return format;
}

const currencyMagnitudeSuffix = [
	{value: 1e6, suffix: 'M'},
	{value: 1e3, suffix: 'k'}
]

// Format currency amounts as e.g. $25k or $1M
export function abbreviateBigCurrency(currencyValue, options) {
	const dollars = currencyValue.dollars();
	const magnitudeSuffix = currencyMagnitudeSuffix.find(({value}) => (dollars >= value));
	if (!magnitudeSuffix) {
		return omitZeroCents(currencyValue, options);
	}
	const rounded = Math.round(dollars / magnitudeSuffix.value);
	return `${currency(rounded).format(omitZeroCents)}${magnitudeSuffix.suffix}`;
}